import { Component, OnInit } from '@angular/core';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';

@Component({
	selector: 'register-impactXurgencyXseverity',
	templateUrl: './impact-xurgency-xseverity.component.html',
	styleUrl: './impact-xurgency-xseverity.component.scss',
})
export class ImpactXurgencyXseverityComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_geral_urgencia: 'Urgency',
		lbl_geral_impacto: 'Impact',
		lbl_geral_severidade: 'Severity',
	};

	constructor(private LabelsService: LabelsService) {}

	isLoadingLabels = true;

	selectedTab = 'urgency';

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe({
			next: (labels) => {
				this.labels = labels;
			},
			complete: () => {
				this.isLoadingLabels = false;
			},
		});
	}
}
